import { ELearning } from '../models/e-learning';
import { Learner } from '../models/learner';
import { User } from '../models/user';
import { appConfig } from '../services/app.config';

export const TAB_QUERY_PARAM = 'tab';
export const ID_QUERY_PARAM = 'confirmationId';

/** Redirect to home page */
function toHomePage() {
  window.location.href = window.location.origin;
}

/**
 * Redirect to V1 url app.
 * @param {string} url URL to navigate.
 */
function toV1Url(url) {
  const { origin } = window.location;
  const newUrl = new URL(url, origin);
  window.location.href = newUrl.toString();
}

/**
 * Redirect to e-learning registration page in V1 app.
 * @param {ELearning["confirmationId"]} confirmationId E-learning confirmation ID to navigate.
 */
function toV1ELearningRegistrationPage(confirmationId) {
  toV1Url(`/elearning/elearningControl.php?registrationID=${confirmationId}`);
}

/**
 * Get APEX host.
 * @returns {string}
 */
function getV1ApexHost() {
  switch (appConfig.environment) {
    case 'development':
      return 'https://apex.premierfoodsafety.saritasa.rocks';
    case 'staging':
      return 'https://new.apex.gallo.premierfoodsafety.com';
    case 'production':
      return 'https://apexworkplace.com';
    default:
      return 'https://apexworkplace.com';
  }
}

/**
 * Get V1 Apex e-learning admin.
 * @returns {void}
 */
function toV1ApexELearningAdmin() {
  const url = `${getV1ApexHost()}/elearning/admin.php`;
  return toV1Url(url);
}

/**
 * Get user's v2 path.
 * @param {User} user User
 * @returns {string}
 */
function getUserV2Path(user) {
  switch (true) {
    case user.isStudent:
      return '/student';
    case user.isGroupAdmin:
      return '/group-admin';
    case user.isPfsAdmin:
      return '/pfs-admin';
    case user.isSme:
      return '/sme';
    default:
      return '/';
  }
}

/**
 * Get student detail url.
 * @param {User} currentUser Current user.
 * @param {User | Learner} learner Learner.
 * @param {string | undefined} toTab Redirect to tab.
 * @param {string | null} confirmationId Show specific id detail.
 * @returns {string}
 */
function getStudentDetailUrl(currentUser, learner, toTab, confirmationId = null) {
  if (!learner || !learner.id) {
    return '';
  }

  const basePath = currentUser.isPfsAdmin ? '/pfs-admin/student' : '/group-admin/student';
  const url = new URL(`${basePath}/${learner.id}`, window.location.origin);
  const urlParams = new URLSearchParams(url.search);
  if (toTab) {
    urlParams.set(TAB_QUERY_PARAM, toTab);
  }
  if (confirmationId) {
    urlParams.set(ID_QUERY_PARAM, confirmationId);
  }
  url.search = urlParams.toString();
  return `${url.pathname}${url.search}`;
}

export const redirectUtils = {
  toHomePage,
  toV1Url,
  getStudentDetailUrl,
  getUserV2Path,
  toV1ApexELearningAdmin,
  toV1ELearningRegistrationPage,
};
